import { useEffect } from 'react';
import postClientCart from 'src/api/requests/postClientCart';
import { useIntl } from 'react-intl';
import useCartStore from 'src/hooks/useCart';
import useAuthorizationStore from './useAuthorizationStore';
import useNotification, { NotificationType } from './useNotification';
import trns from './trns';
import useGTAG from './useGTAG';

export const useCartHooks = (): void => {
  const intl = useIntl();
  const { showNotification } = useNotification();
  const { userToken } = useAuthorizationStore();
  const { simpleCartItems, addedDrugsCounter, cleanDrugsCounter } =
    useCartStore();
  const { trackGtagEvent } = useGTAG();

  useEffect(() => {
    const saveCard = async () => {
      if (
        userToken &&
        userToken !== 'undefined' &&
        userToken !== 'null' &&
        simpleCartItems?.length
      ) {
        try {
          const attr = {
            useCache: false,
            authRequired: true
          };
          const simpleCartItemsForSave = simpleCartItems?.map((item) => {
            const { unitQuantity, ...rest } = item;
            if (unitQuantity === 0) {
              return rest;
            }
            return item;
          });
          await postClientCart(simpleCartItemsForSave, attr);
        } catch (err) {
          showNotification({
            message: intl.formatMessage(trns.unExpectedError),
            type: NotificationType.Error
          });
        }
      }
    };

    saveCard();
  }, [userToken, JSON.stringify(simpleCartItems)]);

  useEffect(() => {
    if (
      addedDrugsCounter > 0 &&
      simpleCartItems &&
      simpleCartItems?.length > 0
    ) {
      const lastAddedDrug = simpleCartItems[simpleCartItems?.length - 1];
      if (lastAddedDrug) {
        if (lastAddedDrug.gtagPrefix !== 'item') {
          trackGtagEvent(
            `${lastAddedDrug.gtagPrefix}_item_add`,
            lastAddedDrug.name
          );
        } else {
          trackGtagEvent(`${lastAddedDrug.gtagPrefix}_add`);
        }
      }
    }
    return () => {
      cleanDrugsCounter();
    };
  }, [addedDrugsCounter, JSON.stringify(simpleCartItems)]);
};
